<template>
  <a-modal
    width="325px"
    height="225px"
    centered
    class="activity-modal2"
    v-model="$store.state.activityModal.visible"
    :footer="null"
    :title="false"
    :closable="false"
  >
    <div class="text-center">
      <div @click="onClickImgHandle">
        <img class="active-pic" :src="$store.state.activityModal.imageUrl" />
      </div>
      <p class="close-layer">
        <img
          src="@/assets/active/close.png"
          @click="onClickCloseHandle"
          class="close-btn"
        />
      </p>
    </div>
  </a-modal>
</template>

<script>
import { linkSkip } from '@/util/util'
import { adRecordBanner } from '@/api/land'

export default {
  name: 'ActivityModal',
  mounted () {
    adRecordBanner([{ posterId: this.$store.state.activityModal?.posterId, incrViewCount: 1 }])
  },
  methods: {
    onClickCloseHandle () {
      this.$store.commit('SET_ACTIVITY_MODAL_VISIBLE', false)
    },
    onClickImgHandle () {
      adRecordBanner([
        {
          posterId: this.$store.state.activityModal.posterId,
          incrClickCount: 1
        }
      ])
      let url = this.$store.state.activityModal.linkUrl
      linkSkip(url)
    }
  }
}
</script>

<style>
.activity-modal2 {
}

.activity-modal2 .ant-modal-content {
  max-height: 225px;
}

.activity-modal2 .ant-modal-body {
  padding: 0;
  overflow: visible;
}

.activity-modal2 .close-layer {
  position: absolute;
  bottom: -80px;
  color: #fff;
  font-size: 36px;
  cursor: pointer;
  text-align: center;
  width: 100%;
}

.activity-modal2 .active-pic {
  max-width: 350px;
  max-height: 225px;
}

.activity-modal2 .close-btn {
  color: #fff;
  font-size: 36px;
  margin: 40px 0 0;
  cursor: pointer;
  width: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/activityModal.vue